"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorSection = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var analytics_subjects_1 = require("../../analytics-subjects");
var internal_tracker_1 = require("../../internal-tracker");
var copy_1 = require("./copy");
var ErrorSection = function (_a) {
    var _b;
    var _c = _a.alertLevel, alertLevel = _c === void 0 ? 'warn' : _c, id = _a.id, headingComponent = _a.headingComponent, errorMetadata = _a.errorMetadata, customVariant = _a.variant, rest = __rest(_a, ["alertLevel", "id", "headingComponent", "errorMetadata", "variant"]);
    var _d = (0, __1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    var _e = (0, __1.useComponents)(), Heading1 = _e.Heading1, Notification = _e.Notification;
    var Heading = headingComponent || Heading1;
    var variant = customVariant
        ? customVariant
        : alertLevel === 'warn'
            ? 'warning'
            : 'error';
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.ERROR_SECTION, properties: (_b = {
                errorId: id,
                alertLevel: alertLevel,
                errorMetadata: errorMetadata
            },
            _b[internal_tracker_1.INTERNAL_EVENT_FLAG] = true,
            _b) },
        react_1.default.createElement(Notification, __assign({ id: id, variant: variant }, rest),
            react_1.default.createElement(Heading, null, copy('errorSectionTitle')),
            react_1.default.createElement(Copy, { copyKey: "errorSectionBody" }))));
};
exports.ErrorSection = ErrorSection;
